// src/utils/sync.js
// Guarded Background Sync registration.
//
// iOS Safari (and some other browsers) have no SyncManager, so calling
// registration.sync.register(...) throws synchronously or rejects. Unguarded calls
// produced unhandled rejections on the "online" event. This helper no-throws and
// no-ops where Background Sync is unsupported — the service worker already falls
// back to a setTimeout-based replay in that case, so offline queue replay still works.
export const registerReplaySync = () => {
  if (typeof navigator === "undefined" || !("serviceWorker" in navigator)) return;
  navigator.serviceWorker.ready
    .then((registration) => {
      if (
        typeof window !== "undefined" &&
        "SyncManager" in window &&
        registration.sync
      ) {
        return registration.sync.register("replay-queued-requests");
      }
      return null;
    })
    .catch((err) => {
      if (process.env.NODE_ENV !== "production") {
        // eslint-disable-next-line no-console
        console.warn("[SW] replay sync unavailable:", (err && err.message) || err);
      }
    });
};
